module.exports = __webpack_public_path__ + "media/dashboard/assets/images/kata/channel-instagram-ae1b29d4edd8c2e7727cd6ec79d79fa1.svg";